/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import { useLottie } from 'lottie-react';
import React, { memo, useMemo } from 'react';
import * as loaderCircle from './animationData/loader-circle.json';
import * as loaderLinear from './animationData/loader-linear.json';

import './styles.scss';
import { LoaderProps } from './types';
import { generateID } from '../../base/helper';

/**
 * UI Toolkit Loader component
 * @public
 */
const Loader: React.FC<LoaderProps> = ({
  id = generateID('clientos-ui-toolkit-loader'),
  type = ' circular',
  variant = 'large'
}) => {
  const options = useMemo(
    () => ({
      animationData: type === 'circular' ? loaderCircle : loaderLinear
    }),
    [type]
  );

  const { View } = useLottie(options);

  return (
    <div
      className={`ui-toolkit-loader ${variant}`}
      id={id}
    >
      {View}
    </div>
  );
};

export default memo(Loader);
